"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var SubscriptionTerms = function SubscriptionTerms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.SUBSCRIPTION_TERMS_RECEIVED:
      return payload;

    default:
      return state;
  }
};

var _default = SubscriptionTerms;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/SubscriptionTerms.js
// module id = 538
// module chunks = 5 6